import React from 'react'

/**
 * BlockDivider - Reusable Section Divider
 *
 * Standardized divider for separating main blocks
 * in multi-part presentations
 */

export interface BlockDividerProps {
  number?: number
  emoji: string
  title: string
  subtitle: string
  stats: string
}

export const BlockDivider: React.FC<BlockDividerProps> = ({
  number,
  emoji,
  title,
  subtitle,
  stats,
}) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-blue-600 via-purple-600 to-pink-600 text-white p-12">
      <div className="text-center space-y-8 max-w-4xl">
        {/* Emoji Icon */}
        <div className="text-9xl animate-bounce-slow">{emoji}</div>

        {/* Block Number (optional) */}
        {number && (
          <div className="text-xl font-light opacity-90">Block {number}</div>
        )}

        {/* Title */}
        <h1 className="text-7xl font-bold leading-tight">{title}</h1>

        {/* Subtitle */}
        <p className="text-3xl font-light opacity-90">{subtitle}</p>

        {/* Stats */}
        <div className="text-2xl font-light opacity-75 pt-6 border-t border-white/30">
          {stats}
        </div>
      </div>
    </div>
  )
}

BlockDivider.displayName = 'BlockDivider'

export default BlockDivider
